import React from 'react';

export default function Entry() {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M30.2223 15.9996C30.2223 23.8543 23.8548 30.2218 16.0001 30.2218C8.14534 30.2218 1.77783 23.8543 1.77783 15.9996C1.77783 8.14485 8.14534 1.77734 16.0001 1.77734C23.8548 1.77734 30.2223 8.14485 30.2223 15.9996Z"
        fill="white"
      />
      <path
        d="M29.7223 15.9996C29.7223 23.5781 23.5786 29.7218 16.0001 29.7218V30.7218C24.1309 30.7218 30.7223 24.1304 30.7223 15.9996H29.7223ZM16.0001 29.7218C8.42148 29.7218 2.27783 23.5781 2.27783 15.9996H1.27783C1.27783 24.1304 7.86919 30.7218 16.0001 30.7218V29.7218ZM2.27783 15.9996C2.27783 8.42099 8.42148 2.27734 16.0001 2.27734V1.27734C7.86919 1.27734 1.27783 7.86871 1.27783 15.9996H2.27783ZM16.0001 2.27734C23.5786 2.27734 29.7223 8.42099 29.7223 15.9996H30.7223C30.7223 7.86871 24.1309 1.27734 16.0001 1.27734V2.27734Z"
        fill="black"
      />
      <path
        d="M11.0615 8.88867V8.38867H10.5615V8.88867H11.0615ZM22.1232 8.88867H22.6232V8.38867H22.1232V8.88867ZM22.1232 23.1109V23.6109H22.6232V23.1109H22.1232ZM11.0615 23.1109H10.5615V23.6109H11.0615V23.1109ZM18.5676 15.9998L18.9149 16.3595L19.2875 15.9998L18.9149 15.6401L18.5676 15.9998ZM11.0615 9.38867H22.1232V8.38867H11.0615V9.38867ZM21.6232 8.88867V23.1109H22.6232V8.88867H21.6232ZM22.1232 22.6109H11.0615V23.6109H22.1232V22.6109ZM11.5615 12.0492V8.88867H10.5615V12.0492H11.5615ZM11.5615 23.1109V19.9504H10.5615V23.1109H11.5615ZM7.11084 16.4998H18.5676V15.4998H7.11084V16.4998ZM18.9149 15.6401L14.8232 11.6895L14.1286 12.4089L18.2203 16.3595L18.9149 15.6401ZM18.2203 15.6401L14.1286 19.5907L14.8232 20.3101L18.9149 16.3595L18.2203 15.6401Z"
        fill="black"
      />
    </svg>
  );
}
